import React, { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

/**
 * LanguageProvider - Wrapper around i18next for backward compatibility
 * This provider makes i18next work with existing code that uses useLanguage()
 */
export const LanguageProvider = ({ children }) => {
  const { t, i18n } = useTranslation();

  // Create a backward-compatible API
  const value = {
    language: i18n.language,
    setLanguage: (lang) => {
      i18n.changeLanguage(lang);
    },
    t: (key) => {
      // Support nested keys like 'notFound.title'
      return t(key);
    },
    // For components that might use these
    getProductTranslation: (product) => {
      // Fallback: return original product data
      // You can extend this later to support product-specific translations
      return product;
    },
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
